module.exports = __webpack_public_path__ + "plansza_01e-blue.png?1716dc3c62829f654b082e4ade63fe91";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/plansza_01e-blue.png
// module id = 261
// module chunks = 0